import React from 'react'
import { TopicNotSelectedGuard } from '../../../share/guards'
import EmptySearchMetricSeriesGuard from './EmptySearchMetricSeriesGuard'

const SourceAreaWidgetSettingGuards = ({
  widgetId,
  children
}: {
  widgetId: number
  children: React.ReactElement
}) => (
  <TopicNotSelectedGuard widgetId={widgetId}>
    <EmptySearchMetricSeriesGuard widgetId={widgetId}>{children}</EmptySearchMetricSeriesGuard>
  </TopicNotSelectedGuard>
)

export default SourceAreaWidgetSettingGuards
